import React, {FC} from 'react';
import EvChargerHeader from 'evcharging/containers/ev-charger/EvChargerHeader';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import {createGetServerSideProps, StaticPageProps} from 'evcharging/app';
import Spacer from 'evcharging/components/Spacer';
import Footer from 'evcharging/containers/layout/Footer';
import RequestConsultation from 'evcharging/containers/layout/RequestConsultation';
import ProductImages from 'evcharging/containers/ev-charger/ProductImages';
import PerfectChoice from 'evcharging/containers/ev-charger/PerfectChoice';
import SafeAndReliable from 'evcharging/containers/ev-charger/SafeAndReliable';
import UserFriendly from 'evcharging/containers/ev-charger/UserFriendly';
import TechnicalDetails from 'evcharging/containers/ev-charger/TechnicalDetails';
import {EV_CHARGER_LINK} from 'evcharging/app/seo/pages';
import FaqSection from 'evcharging/containers/layout/FaqSection';
import StayUpdated from 'evcharging/containers/layout/StayUpdated';
import EndToEnd from 'evcharging/containers/layout/EndToEnd';
import {I18nPage} from "i18n/types/pages.enum";

const EvChargerPage: FC<StaticPageProps> = ({ page }) => (
  <Page
    locales={page.locales}
    title={page.meta_title}
    description={page.meta_description}
  >
    <Navigation />
    <EvChargerHeader />
    <Spacer value={40} mobile={20} />
    <ProductImages />
    <PerfectChoice />
    <SafeAndReliable />
    <UserFriendly />
    <TechnicalDetails />
    <EndToEnd />
    <RequestConsultation />
    <FaqSection faqs={page.faqs} />
    <StayUpdated />
    <Footer />
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  EV_CHARGER_LINK,
  undefined,
  [I18nPage.EvChargingCommon, I18nPage.Blog, I18nPage.EvChargingCharger, I18nPage.EnergyRates]
);

export default EvChargerPage;
